import { useMemo } from "react";
import { TAB_ID_SET } from "../config/constants";
import useBasicFormData from "../store/useBasicFormData";

export default function useReserveStoreInfo() {
  const { basicFormData } = useBasicFormData();

  return useMemo(() => {
    if (basicFormData.storeTimeStepData) {
      const {
        reserveType: reserveTabIndex,
        storeDataByStoreTab,
        storeDataByDateTab,
      } = basicFormData.storeTimeStepData;

      // 选择门店维度
      if (reserveTabIndex === TAB_ID_SET.STORE_TAB) {
        return storeDataByStoreTab;
      }

      // 日期维度
      if (reserveTabIndex === TAB_ID_SET.DATE_TAB) {
        return storeDataByDateTab;
      }
    }
    return null;
  }, [basicFormData.storeTimeStepData]);
}
